export default "__VITE_ASSET__DZtfFNa8__"